import { render, staticRenderFns } from "./PoliciesOther.vue?vue&type=template&id=dedbb966"
import script from "./PoliciesOther.vue?vue&type=script&lang=js"
export * from "./PoliciesOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports